module.exports = __webpack_public_path__ + "static/media/0323_IMG_LE_FROMAGER_FE.d431ce91.webp";